import { render, staticRenderFns } from "./JdSkuDetail.vue?vue&type=template&id=a233cbea&scoped=true"
import script from "./JdSkuDetail.vue?vue&type=script&lang=js"
export * from "./JdSkuDetail.vue?vue&type=script&lang=js"
import style0 from "./JdSkuDetail.vue?vue&type=style&index=0&id=a233cbea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a233cbea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a233cbea')) {
      api.createRecord('a233cbea', component.options)
    } else {
      api.reload('a233cbea', component.options)
    }
    module.hot.accept("./JdSkuDetail.vue?vue&type=template&id=a233cbea&scoped=true", function () {
      api.rerender('a233cbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/jdSkuList/components/JdSkuDetail.vue"
export default component.exports